import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import YearRangePicker from "../../../../components/YearRangePicker";

const Controls = ({
	yearRange,
	setYearRange,
	weightFrom,
	onWeightFromChange,
	weightTo,
	onWeightToChange,
	isLoading,
	onSubmit,
}) => {
	const { t } = useTranslation();

	return (
		<Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label">
						{t("year")}:
					</Typography>
				</Box>
				<YearRangePicker
					minYear={new Date().getFullYear() - 2}
					maxYear={new Date().getFullYear()}
					onSelect={(startYear, endYear) => {
						setYearRange({ startYear, endYear });
					}}
					startYear={yearRange?.startYear}
					endYear={yearRange?.endYear}
				/>
			</Box>
			<Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography variant="label" component="label">
						{t("cargos_label")}:
					</Typography>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightFrom"
						sx={{ color: "#7F7F7F" }}
					>
						{t("from")}
					</Typography>
					<TextField
						id="weightFrom"
						size="small"
						value={weightFrom}
						variant="outlined"
						onChange={onWeightFromChange}
						sx={{ width: "80px" }}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
				<Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<Typography
						variant="label"
						component="label"
						htmlFor="weightTo"
						sx={{ color: "#7F7F7F" }}
					>
						{t("to")}
					</Typography>
					<TextField
						id="weightTo"
						size="small"
						value={weightTo}
						variant="outlined"
						sx={{ width: "80px" }}
						onChange={onWeightToChange}
						slotProps={{
							input: {
								endAdornment: "t",
							},

							inputLabel: { shrink: true },
						}}
					/>
				</Box>
			</Box>
			<Box>
				<Button
					loading={isLoading}
					onClick={onSubmit}
					type="button"
					fullWidth
					variant="contained"
				>
					{t("change")}
				</Button>
			</Box>
		</Box>
	);
};

export default Controls;
